import { ModalV2 } from 'components/Common/ModalV2'
import { IconExclamationCircle } from '@tabler/icons-react'
import React from 'react'
import { ErrorModal } from 'components/ErrorModal'

interface ErrorBoundaryState {
  hasError: boolean
  errorMessage: string
  errorCode: string
  isModalOpen: boolean
}

interface ErrorBoundaryProps {
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      errorMessage: '',
      errorCode: '',
      isModalOpen: false,
    }
  }

  static getDerivedStateFromError(error: any): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      errorMessage: error?.description,
      errorCode: error?.error,
      isModalOpen: true,
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can log the error to an error reporting service here
    console.error('Uncaught error:', error, errorInfo)
  }

  updateModalState = (isOpen: boolean) => {
    this.setState({ isModalOpen: isOpen })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.state.errorCode === 'not_enough_words') {
        return (
          <>
            <ErrorModal
              open={this.state.isModalOpen}
              onClose={() => this.updateModalState(false)}
              title="Not Enough Words"
              description={this.state.errorMessage}
            />
            {this.props.children}
          </>
        )
      }
      return <>{this.props.children}</>
    }

    return this.props.children
  }
}

export default ErrorBoundary
